module.exports = __webpack_public_path__ + "static/media/icon-reply-black.d2abdb07.svg";